// extracted by mini-css-extract-plugin
module.exports = {"container":"xq","discount":"yq","price":"zq","originalPrice":"Aq","msrp":"Bq","percentOff":"Cq","percentOffBanner":"Dq","sale":"Eq"};